import styles from './webkua-product-select.module.scss';
import { useState } from 'react';
import { Autocomplete, Checkbox, Chip, FormControl, ListItemText, MenuItem, TextField } from '@frontend-workspace/react-shared-lib';
import { IRelationProduct } from '../_models/relation-product';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface WebkuaProductSelectProps {
  relationProducts: IRelationProduct[];
  selectedProductIds: string[];
  setSelectedProductIds: (selectedProductIds: string[]) => void
}

export function WebkuaProductSelect(props: WebkuaProductSelectProps) {
  const { t } = useTranslation();
  const [productIds, setProductIds] = useState(props.selectedProductIds);

  const handleProductChange = (productId: string) => {
    const newProductIds = productIds.includes(productId)
      ? productIds.filter(id => id !== productId)
      : [...productIds, productId];
    setProductIds(newProductIds);
  }
  const onClose = (event: any) => props.setSelectedProductIds(productIds);

  const getOptionLabel = (groupId: any) => {
    const product = props.relationProducts.find(product => product.id === groupId);
    return `${product?.productName}`;
  }

  return (
    <FormControl sx={{ width: 700 }}>
      <Autocomplete
        multiple
        limitTags={1}
        value={productIds}
        onClose={onClose}
        getOptionLabel={(groupId) => getOptionLabel(groupId)}
        renderTags={(value, getTagProps) => {
          const numTags = value.length;
          const limitTags = 1;
          return (
            <>
              {value.slice(0, limitTags).map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={index}
                  label={getOptionLabel(option)}
                />
              ))}
              {numTags > limitTags && ` +${numTags - limitTags}`}
            </>
          );
        }}
        options={props.relationProducts}
        renderInput={(params: any) => (
          <TextField
            {...params}
            fullWidth

            label={t("standard.selectProducts")}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && event.target.value !== '') {
                // Prevent default action of the enter key
                event.preventDefault();
                // Filter options based on input and select all
                const filteredOptions = props.relationProducts.filter(option =>
                  option.productName.toLowerCase().includes(event.target.value.toLowerCase())
                );
                setProductIds(filteredOptions.map(option => option.id));
                props.setSelectedProductIds(filteredOptions.map(option => option.id));
              }
            }}

          />
        )}
        filterOptions={(options, state: any) => {
          return options.filter(option =>
            option.productName.toLowerCase().includes(state.inputValue.toLowerCase())
          );
        }}
        renderOption={(props: any, option: any) => {
          return <MenuItem key={option.id} value={option.id} >
            <Checkbox
              checked={productIds.includes(option.id)}
              onChange={(event: any) => handleProductChange(option.id)}
            />
            <ListItemText primary={option.productName} />
          </MenuItem>
        }}
        onChange={(event: any, groupIds: any) => {
          setProductIds(groupIds);
          props.setSelectedProductIds(groupIds);
        }}
      />
    </FormControl>
  );
}

export default WebkuaProductSelect;
